import React, { useState } from 'react';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import './RejectPlanModal.css';

const RejectPlanModal = ({ show, onHide, isRejecting }) => {

    const [remarks, setRemarks] = useState('');
    const [selectedReason, setSelectedReason] = useState(null);

    const reasonList = [
        { Code: "R001", Description: "Schedule conflict with another plan" },
        { Code: "R002", Description: "Insufficient resources available" },
        { Code: "R003", Description: "Plan does not align with company priorities" },
        { Code: "R004", Description: "Missing required information" },
        { Code: "R005", Description: "Incorrect data provided in the plan" },
        { Code: "R006", Description: "Duplicate submission of plan" },
        { Code: "R007", Description: "Plan submitted after the deadline" },
    ];

    return (
        <Modal className='reject-plan-modal' show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                Reject Plan
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mt-3">
                    <Form.Label>Reason</Form.Label>
                    <Dropdown >
                        <Dropdown.Toggle className="form-control text-start">
                            {selectedReason
                                ? (
                                    <span>
                                        <span className='text-code me-1'>{selectedReason.Code}</span>
                                        <span>{selectedReason.Description}</span>
                                    </span>
                                )
                                : "-- Select Reason --"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100">
                            {reasonList.map(reason => (
                                <Dropdown.Item
                                    key={reason.Code}
                                    onClick={() => setSelectedReason(reason)}
                                >
                                    <span className='text-code me-1'>{reason.Code}</span>
                                    <span>{reason.Description}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Form.Group>

                <Form.Group className="m-0 my-2 w-100">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <Button className="btn-reject d-flex px-5" disabled={isRejecting} onClick={onHide}>
                    <span className="text-nowrap">Reject</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RejectPlanModal;
